// Deps
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

/**
 * Collapse Slider Swiper
 * ------------------------------------------------------- *
 */
// eslint-disable-next-line camelcase
const collapse_slider = ( function( document ) {
	var selector = '[data-collapse-slider]';
	var readMoreButtonClass = '.more';
	var moreLessTextClass = '.ml_text';
	var section = '.section--collapse-slider';
	var collapseBlockClass = '.collapse-block';
	var collapseElement = '.collapse-item';
	var readMoreText = 'Read more';
	var readLessText = 'Read less';
	var swipers = [];
	var options = {
		loop: true,
		autoplay: {
			delay: 3000
		},
		disableOnInteraction: true,
		pagination: {
			clickable: true,
			el: '.swiper-pagination',
			type: 'bullets'
		},
		on: {
			slideChangeTransitionStart: function( sw ) {
				changeCollapse( sw.el, sw.realIndex, true );
				changeReadMore( sw.el, sw.realIndex );
			}
		}
	};

	Swiper.use([ Navigation, Pagination, Autoplay ]);

	const _instance = {};

	function init() {
		applySlider();
		applyReadMore();
	}

	/**
	 * Apply all sliders
	 */
	function applySlider() {
		const elements = document.querySelectorAll( selector );

		for ( let i = 0; i < elements.length; i++ ) {
			swipers.push( new Swiper( '[data-collapse-slider="' + elements[i].dataset.collapseSlider + '"]', options ) );
		}
	}

	/**
	 * Apply all read more buttons
	 */
	function applyReadMore() {
		const readMore =  document.querySelectorAll( readMoreButtonClass );

		for ( let i = 0; i < readMore.length; i++ ) {
			readMore[i].querySelector( 'span' ).textContent = readMoreText;

			readMore[i].addEventListener( 'click', function( el ) {
				el.preventDefault();

				let readMoreButton = el.target.closest( readMoreButtonClass );

				let swiperIndex = readMoreButton.dataset.swiperIndex;
				let activeSliderIndex  = swipers[swiperIndex].realIndex;
				let collapseBlock = el.target.closest( collapseBlockClass );

				collapseBlock.classList.toggle( 'active' );

				if ( collapseBlock.classList.contains( 'active' ) ) {
					swipers[swiperIndex].autoplay.stop();
				} else {
					swipers[swiperIndex].autoplay.start();
				}

				readMoreButton.querySelector( moreLessTextClass ).textContent = collapseBlock.classList.contains( 'active' ) ? readLessText : readMoreText;

				changeCollapse( el.target, activeSliderIndex );
			});
		}
	}

	/**
	 * Change read more section
	 *
	 * @param el
	 * @param realIndex
	 */
	function changeReadMore( el, realIndex ) {
		let collapseBlock = el.closest( section ).querySelector( collapseBlockClass );

		if ( collapseBlock.querySelector( '[data-slider-key="' + realIndex + '"]' ) ) {
			collapseBlock.querySelector( readMoreButtonClass ).classList.add( 'active' );
		} else {
			collapseBlock.querySelector( readMoreButtonClass ).classList.remove( 'active' );
		}

		collapseBlock.classList.remove( 'active' );
		collapseBlock.querySelector( moreLessTextClass ).textContent = readMoreText;
	}

	/**
	 * Show|hide collapse section
	 *
	 * @param el
	 * @param sliderIndex
	 * @param hide
	 */
	function changeCollapse( el, sliderIndex, hide = false ) {
		var collapseElements = el.closest( section ).querySelectorAll( collapseElement );

		for ( let i = 0; i < collapseElements.length; i++ ) {
			if ( collapseElements[i].dataset.sliderKey == sliderIndex && ! hide ) {
					collapseElements[i].classList.toggle( 'active' );
			} else {
				collapseElements[i].classList.remove( 'active' );
			}
		}
	}

	/**
	* Public
	*/
	_instance.init = function() {
		init();
	};

	return _instance;
}( document ) );

// eslint-disable-next-line camelcase
export default collapse_slider;
